/* unplugin-vue-components disabled */import script from "./Mobile.vue?vue&type=script&lang=ts&setup=true"
export * from "./Mobile.vue?vue&type=script&lang=ts&setup=true"

import "./Mobile.vue?vue&type=style&index=0&id=734283df&lang=less&scoped=true"

import exportComponent from "E:\\meari\\cloudMall\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-734283df"]])

export default __exports__